import { ENTITY_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const getListPersons = async ({ token, filtro, callbacks }) => {
    const response = await connection({ method: 'GET', url: `${ENTITY_URL.PERSONA.LIST}`, extraHeaders: { token: token }, params: { filtro } });;
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}
export default getListPersons;